import { useMemo } from "react";
import { SegmentedControl } from "./SegmentedControl";

interface ImageShapeControlProps {
  value: string;
  onChange: (value: string) => void;
  options: string[];
}

const LABELS: Record<string, string> = {
  square: "Square",
  rounded: "Rounded",
  circle: "Circle",
};

/**
 * Segmented toggle for image shape options.
 * Renders 2 or 3 segments depending on which options the section's schema allows.
 */
export function ImageShapeControl({
  value,
  onChange,
  options,
}: ImageShapeControlProps) {
  const mapped = useMemo(
    () => options.map((opt) => ({ label: LABELS[opt] || opt, value: opt })),
    [options],
  );

  return (
    <SegmentedControl
      label="Image shape"
      options={mapped}
      value={value}
      onChange={onChange}
    />
  );
}
